import { useEffect } from "react";

const VslRedirect = () => {
  useEffect(() => {
    window.location.replace("/tus25000dolares.html");
  }, []);
  return (
    <div data-testid="vsl-redirect" style={{ minHeight: "100vh", background: "#04140f" }} />
  );
};

export default VslRedirect;
